import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid } from '@material-ui/core';
import { getClaimStatusTranslation } from '../../helpers/langHelpers';
import { reformatDate } from '../../helpers/dates';
import { DATE_FORMAT_DISPLAY, DATE_FORMAT_WITH_TIME } from '../../constants';

import styles from './ClaimFrame.module.scss';

const ClaimFrame = ({ claim, children }) => {
  const { t } = useTranslation();
  return (
    <>
      <Grid container justifyContent="space-between" className={styles.header}>
        <Grid item xs={5}>
          <div className={styles.claimNumber}>{claim.claimNumber}</div>
          <div className={styles.claimDate}>
            {claim.claimDate
              ? reformatDate(claim.claimDate, DATE_FORMAT_WITH_TIME, DATE_FORMAT_DISPLAY)
              : '-'}
          </div>
        </Grid>
        <Grid item xs={7} className={styles.right}>
          {!claim.isCasco && (
            <>
              <div className={styles.claimInfoRow}>
                <span>{t('claim.claimInfo.expert')}</span>
                <span>{getClaimStatusTranslation(claim, 'expert') || '-'}</span>
              </div>
              <div className={styles.claimInfoRow}>
                <span>{t('claim.claimInfo.category')}</span>
                <span>{getClaimStatusTranslation(claim, 'claimType') || '-'}</span>
              </div>
            </>
          )}
        </Grid>
      </Grid>
      <div className={styles.claimFrameBody}>{children}</div>
    </>
  );
};

ClaimFrame.propTypes = {
  claim: PropTypes.shape({
    claimNumber: PropTypes.string,
    claimDate: PropTypes.string,
    expert: PropTypes.string,
    claimType: PropTypes.string,
    risks: PropTypes.arrayOf(PropTypes.shape({ risk: PropTypes.string })),
    isCasco: PropTypes.bool,
  }).isRequired,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
};

ClaimFrame.defaultProps = {
  children: null,
};

export default ClaimFrame;
